<template>
  <div class="global-content-box global-content-flex">
    <y-back-action
      :title="['会员总览']"
      subTitle="会员详情"
      @back="closePage"
    />
    <div class="global-felx">
      <!-- 基本信息 -->
      <y-title label="基本信息" class="magin-t16" />
      <el-form
        class="basicInfo"
        :model="baseDataForm"
        :inline="true"
        label-position="left"
      >
        <el-form-item label="全渠道会员ID：" prop="memberId">
          <div class="basicTitle">{{ baseDataForm.memberId }}</div>
        </el-form-item>
        <el-form-item label="首次入会时间：" prop="firstJoinTime">
          <div class="basicTitle">{{ baseDataForm.firstJoinTime }}</div>
        </el-form-item>
        <el-form-item label="首次入会店铺：" prop="firstJoinShopName">
          <div class="basicTitle">{{ baseDataForm.firstJoinShopName }}</div>
        </el-form-item>
        <el-form-item label="手机号：" prop="mobile">
          <div class="basicTitle" style="display: flex">
            <!-- v-if="showPhoneNumber" -->
            <span
              >{{ maskedPhoneNumber
              }}<img
                v-show="false"
                slot="reference"
                src="@/assets/images/隐藏.svg"
                alt=""
                @click="togglePhoneNumberVisibility"
                style="
                  margin-left: 12px;
                  cursor: pointer;
                  position: relative;
                  top: 3px;
                "
            /></span>
            <!--  v-else-->
            <span v-if="false"
              >{{ baseDataForm.mobile }}
              <img
                slot="reference"
                src="@/assets/images/显示.svg"
                alt=""
                @click="togglePhoneNumberVisibility"
                style="
                  margin-left: 12px;
                  cursor: pointer;
                  position: relative;
                  top: 3px;
                "
            /></span>
          </div>
        </el-form-item>

        <el-form-item label="累计交易金额：" prop="successMoney">
          <div class="basicTitle">{{ baseDataForm.successMoney }}</div>
        </el-form-item>

        <el-form-item label="姓名：" prop="username">
          <div v-if="isEidtName" class="basicTitle displayItem">
            <el-input
              size="small"
              placeholder="请输入"
              style="width: 160px"
              maxlength="8"
              v-model="name"
            ></el-input>
            <img
              slot="reference"
              src="@/assets/images/memberAll/save.png"
              alt=""
              style="margin: 0 0 0 15px; cursor: pointer; width: 16px"
              @click="updateDetail()"
            />
            <img
              @click="isEidtName = false"
              slot="reference"
              src="@/assets/images/memberAll/cancel.png"
              alt=""
              style="margin: 0 0 0 15px; cursor: pointer; width: 16px"
            />
          </div>
          <div v-else class="basicTitle displayItem">
            <div class="basicTitle displayItem">
              {{ baseDataForm.username ? baseDataForm.username : "--" }}

              <div @click="isEidtName = true">
                <div class="editIcon" slot="reference">
                  <img
                    style="cursor: pointer; width: 14px; height: 15px"
                    class="edit"
                    src="@/assets/images/memberAll/edit_d.svg"
                    alt=""
                  />
                  <img
                    style="cursor: pointer; width: 14px; height: 15px"
                    class="edit_active"
                    src="@/assets/images/memberAll/edit_d_active.svg"
                    alt=""
                    @click="clearotherName()"
                  />
                </div>
              </div>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="性别：" prop="sex">
          <div v-if="isEidtGrender" class="basicTitle displayItem">
            <div class="displayItem">
              <el-select
                class="selectType"
                v-model="gender"
                placeholder="请选择"
                style="width: 186px"
                size="small"
              >
                <el-option
                  v-for="item in grenderList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <img
              slot="reference"
              src="@/assets/images/memberAll/save.png"
              alt=""
              style="margin: 0 0 0 15px; cursor: pointer; width: 16px"
              @click="updateDetail()"
            />
            <img
              @click="isEidtGrender = false"
              slot="reference"
              src="@/assets/images/memberAll/cancel.png"
              alt=""
              style="margin: 0 0 0 15px; cursor: pointer; width: 16px"
            />
          </div>
          <div v-else class="basicTitle displayItem">
            <span v-if="baseDataForm.sex == 1">男</span>
            <span v-else-if="baseDataForm.sex == 2">女</span>
            <span v-else>--</span>

            <div @click="isEidtGrender = true">
              <div class="editIcon" slot="reference">
                <img
                  style="cursor: pointer; width: 14px; height: 15px"
                  class="edit"
                  src="@/assets/images/memberAll/edit_d.svg"
                  alt=""
                />
                <img
                  style="cursor: pointer; width: 14px; height: 15px"
                  class="edit_active"
                  src="@/assets/images/memberAll/edit_d_active.svg"
                  alt=""
                  @click="clearotherGrender()"
                />
              </div>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="生日：" prop="birth">
          <div v-if="isEidtBirth" class="basicTitle displayItem">
            <el-date-picker
              v-model="birthday"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
            >
            </el-date-picker>
            <img
              slot="reference"
              src="@/assets/images/memberAll/save.png"
              alt=""
              style="margin: 0 0 0 15px; cursor: pointer; width: 16px"
              @click="updateDetail()"
            />
            <img
              @click="isEidtBirth = false"
              slot="reference"
              src="@/assets/images/memberAll/cancel.png"
              alt=""
              style="margin: 0 0 0 15px; cursor: pointer; width: 16px"
            />
          </div>
          <div v-else class="basicTitle displayItem">
            {{ baseDataForm.birth ? baseDataForm.birth : "--" }}

            <div @click="isEidtBirth = true">
              <div class="editIcon" slot="reference">
                <img
                  style="cursor: pointer; width: 14px; height: 15px"
                  class="edit"
                  src="@/assets/images/memberAll/edit_d.svg"
                  alt=""
                />
                <img
                  style="cursor: pointer; width: 14px; height: 15px"
                  class="edit_active"
                  src="@/assets/images/memberAll/edit_d_active.svg"
                  alt=""
                  @click="clearotherBirth()"
                />
              </div>
            </div>
          </div>
        </el-form-item>
      </el-form>

      <!-- 会员资产 -->
      <div class="assset">
        <y-title label="会员资产" />
        <y-button
          class="assset-btn"
          type="blueText"
          size="mini"
          :styleTextObj="{ fontSize: '10px' }"
          @click="updateAsset"
          >同步积分和等级</y-button
        >
      </div>

      <el-form class="basicInfo" :inline="true" label-position="left">
        <el-form-item label="会员等级：">
          <div class="basicTitle displayItem">
            <!-- {{ baseDataForm.grade ? 'LV.'+baseDataForm.grade : "--" }} -->
            <!-- 根据 memberLevelList 动态显示当前等级名称 -->
            <span>{{ currentGradeLabel }}</span>

            <el-popover
              placement="bottom-start"
              width="510"
              trigger="click"
              v-model="visibleLevel"
              style="position: relative"
              @click="clearother()"
            >
              <el-form
                label-width="110px"
                :inline="true"
                label-position="right"
                style="padding: 30px 0"
              >
                <el-form-item label="等级修改为：" required>
                  <div class="displayItem">
                    <el-select
                      class="selectType"
                      v-model="gradeForm.grade"
                      placeholder="请选择"
                      style="width: 186px"
                      size="small"
                    >
                      <el-option
                        v-for="item in selectableLevelList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                </el-form-item>
                <el-form-item label="等级有效期：">
                  <div class="my_select_time1">
                    <el-date-picker
                      prefix-icon="no_icon"
                      v-model="gradeForm.gradeValidTime"
                      type="date"
                      :placeholder="'选择日期时间'"
                      size="small"
                      style="width: 186px; font-size: 12px"
                      value-format="yyyy-MM-dd"
                      class="time2"
                      :clearable="false"
                    ></el-date-picker>
                    <i
                      class="el-icon-circle-close date_icon1"
                      @click="clearTimeSendTime()"
                    ></i>
                    <img
                      src="@/assets/images/select_date.svg"
                      alt
                      class="date_icon2"
                    />
                  </div>
                  <div
                    style="font-size: 13px; font-weight: 400; color: #999999"
                  >
                    不设置即为永久有效
                  </div>
                </el-form-item>
                <el-form-item label="备注：" required>
                  <el-input
                    size="small"
                    placeholder="请输入"
                    style="width: 350px"
                    maxlength="20"
                    show-word-limit
                    v-model="gradeForm.remark"
                  ></el-input>
                </el-form-item>
                <el-form-item style="float: right">
                  <y-button type="default" @click="closeBtn">取消</y-button>
                  <y-button type="blue" @click="saveGrade">保存</y-button>
                </el-form-item>
              </el-form>
              <div class="editIcon" slot="reference">
                <img
                  style="cursor: pointer; width: 14px; height: 15px"
                  class="edit"
                  src="@/assets/images/memberAll/edit_d.svg"
                  alt=""
                />
                <img
                  style="cursor: pointer; width: 14px; height: 15px"
                  class="edit_active"
                  src="@/assets/images/memberAll/edit_d_active.svg"
                  alt=""
                  @click="clearother()"
                />
              </div>
            </el-popover>
          </div>
        </el-form-item>
        <el-form-item label="可用积分：" prop="pointBalance">
          <div class="basicTitle displayItem">
            {{ baseDataForm.pointBalance ? baseDataForm.pointBalance : "--" }}

            <el-popover
              placement="bottom-start"
              width="517"
              trigger="click"
              v-model="visibleIntegral"
              style="position: relative"
              @click="clearother()"
            >
              <el-form
                label-width="90px"
                :inline="true"
                label-position="right"
                style="padding: 30px 0"
              >
                <el-form-item required="" label="修改积分:">
                  <el-select
                    v-model="pointForm.scoresType"
                    placeholder="请选择"
                    style="width: 186px; height: 32px"
                  >
                    <el-option
                      v-for="item in integralList"
                      :label="item.label"
                      :value="item.value"
                      :key="item.value"
                    >
                    </el-option>
                  </el-select>
                  <el-input
                    v-model="pointForm.scoresCount"
                    placeholder="请输入内容"
                    maxlength="8"
                    show-word-limit
                    style="width: 186px; height: 32px; margin-left: 8px"
                  >
                  </el-input>
                </el-form-item>
                <el-form-item required="" label="备注:">
                  <el-input
                    v-model="pointForm.remark"
                    placeholder="请输入"
                    style="width: 380px; height: 32px"
                    maxlength="20"
                    show-word-limit
                  ></el-input>
                </el-form-item>
                <el-form-item style="float: right">
                  <y-button type="default" @click="closeBtn">取消</y-button>
                  <y-button
                    type="blue"
                    style="margin-left: 8px"
                    @click="saveScores"
                    >保存</y-button
                  >
                </el-form-item>
              </el-form>
              <div class="editIcon" slot="reference">
                <img
                  style="cursor: pointer; width: 14px; height: 15px"
                  class="edit"
                  src="@/assets/images/memberAll/edit_d.svg"
                  alt=""
                />
                <img
                  style="cursor: pointer; width: 14px; height: 15px"
                  class="edit_active"
                  src="@/assets/images/memberAll/edit_d_active.svg"
                  alt=""
                  @click="clearother()"
                />
              </div>
            </el-popover>
          </div>
        </el-form-item>
        <el-form-item label="成长值：" prop="grow">
          <div class="basicTitle displayItem">
            {{ baseDataForm.grow ? baseDataForm.grow : "--" }}

            <el-popover
              placement="bottom-start"
              width="550"
              trigger="click"
              v-model="visibleGrow"
              style="position: relative"
              @click="clearother()"
            >
              <el-form
                label-width="110px"
                :inline="true"
                label-position="right"
                style="padding: 30px 0"
              >
                <el-form-item required="" label="修改成长值:">
                  <el-select
                    v-model="growForm.scoresType"
                    placeholder="请选择"
                    style="width: 186px; height: 32px"
                  >
                    <el-option
                      v-for="item in growList"
                      :label="item.label"
                      :value="item.value"
                      :key="item.value"
                    >
                    </el-option>
                  </el-select>
                  <el-input
                    v-model="growForm.scoresCount"
                    placeholder="请输入内容"
                    maxlength="8"
                    show-word-limit
                    style="width: 186px; height: 32px; margin-left: 8px"
                  >
                  </el-input>
                </el-form-item>
                <el-form-item required="" label="备注:">
                  <el-input
                    v-model="growForm.remark"
                    placeholder="请输入"
                    style="width: 380px; height: 32px"
                    maxlength="20"
                    show-word-limit
                  ></el-input>
                </el-form-item>
                <el-form-item style="float: right">
                  <y-button type="default" @click="closeBtn">取消</y-button>
                  <y-button
                    type="blue"
                    style="margin-left: 8px"
                    @click="saveGrow"
                    >保存</y-button
                  >
                </el-form-item>
              </el-form>
              <div class="editIcon" slot="reference">
                <img
                  style="cursor: pointer; width: 14px; height: 15px"
                  class="edit"
                  src="@/assets/images/memberAll/edit_d.svg"
                  alt=""
                />
                <img
                  style="cursor: pointer; width: 14px; height: 15px"
                  class="edit_active"
                  src="@/assets/images/memberAll/edit_d_active.svg"
                  alt=""
                  @click="clearother()"
                />
              </div>
            </el-popover>
          </div>
        </el-form-item>
        <el-form-item label="距离下一等级：" prop="nextGradeTip">
          <div class="basicTitle">{{ baseDataForm.nextGradeTip }}</div>
        </el-form-item>
      </el-form>

      <!-- 关联账号 -->
      <y-title label="关联账号" />
      <account-table :memberId="memberId" :shopData="shopData"></account-table>

      <!-- 变更明细 -->
      <y-title label="变更明细" />

      <!-- 变更明细详情table -->
      <change-Table :memberId="memberId" :shopData="shopData"></change-Table>
    </div>
  </div>
</template>

<script>
import changeTable from "./changeTable.vue";
import accountTable from "./accountTable.vue";
import {
  getCDPBuyerDetail,
  updateCDPBuyerBaseDetail,
  editScores,
  editGrow,
  editGrade,
  syncPointAndGrade,
} from "@/api/memberMessageSystem";
export default {
  components: {
    changeTable,
    accountTable,
  },
  props: {
    memberId: {
      type: String,
    },
    // 会员等级列表，由父组件（memberAll.vue）传入，格式 [{ label, value }]
    memberLevelList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      // 会员积分修改弹窗
      visibleIntegral: false,
      visibleGrow: false,
      visibleLevel: false,
      isEidtName: false,
      isEidtGrender: false,
      isEidtBirth: false,
      // 修改积分表单
      // IntegralEdit: "",
      // ModifiedIntegral1: "",
      pointForm: {
        memberId: this.memberId,
        scoresCardId: "",
        scoresType: 0,
        scoresCount: "",
        remark: "",
      },
      //修改成长值
      growForm: {
        memberId: this.memberId,
        scoresCardId: "",
        scoresType: 0,
        scoresCount: "",
        remark: "",
      },
      //修改会员等级
      gradeForm: {
        memberId: this.memberId,
        grade: "",
        gradeValidTime: "",
        remark: "",
        scoresCardId: "",
      },
      //修改之前得默认值
      birthday: "",
      gender: "",
      name: "",
      integralList: [
        {
          value: 0,
          label: "加积分",
        },
        {
          value: 1,
          label: "减积分",
        },
      ],
      growList: [
        {
          value: 0,
          label: "加成长值",
        },
        {
          value: 1,
          label: "减成长值",
        },
      ],
      grenderList: [
        {
          value: 1,
          label: "男",
        },
        {
          value: 2,
          label: "女",
        },
      ],
      // 是否显示手机号码
      showPhoneNumber: true,
      baseDataForm: {},
      shopData: [],
    };
  },
  computed: {
    // 手机号脱敏
    maskedPhoneNumber() {
      // 编写脱敏逻辑，将手机号码转换为脱敏形式
      if (this.baseDataForm.mobile) {
        return this.baseDataForm.mobile.replace(
          /(\d{3})\d{4}(\d{4})/,
          "$1****$2"
        );
      }
    },
    // 当前等级名称：按 baseDataForm.grade 在父组件传入的列表里查 label
    currentGradeLabel() {
      const grade = this.baseDataForm.grade;
      if (grade === "" || grade === null || grade === undefined) {
        return "--";
      }
      const level = (this.memberLevelList || []).find(
        (item) => String(item.value) === String(grade)
      );
      return level ? level.label : grade;
    },
    // 可选等级：去掉父组件列表里「全部」（value 为空），并排除当前等级
    selectableLevelList() {
      return (this.memberLevelList || []).filter((item) => {
        if (
          item.value === "" ||
          item.value === null ||
          item.value === undefined
        ) {
          return false;
        }
        return String(item.value) !== String(this.baseDataForm.grade);
      });
    },
  },
  created() {
    // 获取当前会员体系详情
    this.MemberSystemInfo = this.$store.state.MemberSystemInfo;
    console.log("this.MemberSystemInfo", this.MemberSystemInfo);
  },
  mounted() {
    this.pointForm.scoresCardId = this.MemberSystemInfo.scoresCardId;
    this.growForm.scoresCardId = this.MemberSystemInfo.scoresCardId;
    this.getActivityList();
  },
  methods: {
    clearother() {
      //默认关闭弹窗
      (this.isEidtName = false),
        (this.isEidtGrender = false),
        (this.isEidtBirth = false);
    },
    clearotherName() {
      (this.isEidtGrender = false), (this.isEidtBirth = false);
      this.visibleLevel = false;
      this.visibleGrow = false;
      this.visibleIntegral = false;
    },
    clearotherGrender() {
      (this.isEidtName = false), (this.isEidtBirth = false);
      this.visibleLevel = false;
      this.visibleGrow = false;
      this.visibleIntegral = false;
    },
    clearotherBirth() {
      (this.isEidtName = false), (this.isEidtGrender = false);
      this.visibleLevel = false;
      this.visibleGrow = false;
      this.visibleIntegral = false;
    },
    // 获取活动列表
    getActivityList() {
      getCDPBuyerDetail({ memberId: this.memberId }).then((res) => {
        if (res.code == 200) {
          this.baseDataForm = res.data;
          this.birthday = this.baseDataForm.birth;
          this.gender = Number(this.baseDataForm.sex);
          if (this.gender == 0) this.gender = "";
          this.name = this.baseDataForm.username;

          const keys = Object.keys(res.data.hsMemberSellerManageDetailDTO);
          const shopArr = [];
          if (keys.length) {
            keys.forEach((key) => {
              res.data.hsMemberSellerManageDetailDTO[key].forEach((list) => {
                shopArr.push({
                  platform: key,
                  label: list.sellerManageName,
                  value: list.sellerManageId,
                });
              });
            });
          }
          this.shopData = shopArr;

          console.log("111", this.gender);

          //默认关闭弹窗
          (this.isEidtName = false),
            (this.isEidtGrender = false),
            (this.isEidtBirth = false);

          this.visibleLevel = false;
          this.visibleGrow = false;
          this.visibleIntegral = false;
          this.setClean();
        }
      });
    },
    updateDetail() {
      let param = {
        memberId: this.memberId,
        birth: this.birthday,
        sex: this.gender,
        username: this.name,
      };
      updateCDPBuyerBaseDetail(param).then((res) => {
        if (res.code == 200) {
          this.getActivityList();
        } else {
          (this.isEidtName = false),
            (this.isEidtGrender = false),
            (this.isEidtBirth = false);
        }
      });
    },
    closePage() {
      this.$emit("close");
    },
    // 重置
    setClean() {
      this.pointForm = {
        memberId: this.memberId,
        scoresCardId: this.MemberSystemInfo.scoresCardId,
        scoresType: 0,
        scoresCount: "",
        remark: "",
      };
      //修改成长值
      this.growForm = {
        memberId: this.memberId,
        scoresCardId: this.MemberSystemInfo.scoresCardId,
        scoresType: 0,
        scoresCount: "",
        remark: "",
      };
      //修改会员等级
      this.gradeForm = {
        memberId: this.memberId,
        grade: "",
        gradeValidTime: "",
        remark: "",
      };
    },
    //保存修改积分
    saveScores() {
      if (!this.pointForm.scoresCount) {
        this.$message.warning("请输入修改的积分");
        return;
      }

      if (
        this.pointForm.scoresType == 1 &&
        Number(this.pointForm.scoresCount) >
          Number(this.baseDataForm.pointBalance)
      ) {
        this.$message.warning("请减少的积分不能大于当前积分");
        return;
      }

      if (!this.pointForm.remark) {
        this.$message.warning("请输入备注");
        return;
      }

      this.pointForm.scoresCount = Number(this.pointForm.scoresCount);
      editScores(this.pointForm).then((res) => {
        if (res.code == 200) {
          this.getActivityList();
          this.setClean();
        } else {
          this.$message.warning("编辑失败");
          this.setClean();
        }
      });
    },
    //保存修改成长值
    saveGrow() {
      if (!this.growForm.scoresCount) {
        this.$message.warning("请输入修改的成长值");
        return;
      }

      if (
        this.growForm.scoresType == 1 &&
        Number(this.growForm.scoresCount) > Number(this.baseDataForm.grow)
      ) {
        this.$message.warning("请减少的成长值不能大于当前成长值");
        return;
      }

      if (!this.growForm.remark) {
        this.$message.warning("请输入备注");
        return;
      }

      this.growForm.scoresCount = Number(this.growForm.scoresCount);
      editGrow(this.growForm).then((res) => {
        if (res.code == 200) {
          this.getActivityList();
        } else {
          this.$message.warning("编辑失败");
          this.setClean();
        }
      });
    },
    closeBtn() {
      this.setClean();
      (this.isEidtName = false),
        (this.isEidtGrender = false),
        (this.isEidtBirth = false);

      this.visibleLevel = false;
      this.visibleGrow = false;
      this.visibleIntegral = false;
    },
    // 保存弹窗
    saveGrade() {
      if (!this.gradeForm.grade) {
        this.$message.warning("请输入修改的等级");
        return;
      }
      if (!this.gradeForm.remark) {
        this.$message.warning("请输入备注");
        return;
      }
      editGrade(this.gradeForm).then((res) => {
        if (res.code == 200) {
          this.getActivityList();
        } else {
          this.$message.warning("编辑失败");
          this.setClean();
        }
      });
    },
    // 手机号码的脱敏和显示切换
    togglePhoneNumberVisibility() {
      this.showPhoneNumber = !this.showPhoneNumber;
    },
    clearTimeSendTime() {
      this.gradeForm.gradeValidTime = "";
    },
    // 同步积分和等级
    updateAsset() {
      let param = {
        memberId: this.memberId,
        scoresCardId: this.MemberSystemInfo.scoresCardId,
      };
      syncPointAndGrade(param).then((res) => {
        if (res.code == 200) {
          this.$message.success("已同步成功，请核对...");
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.assset {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  &-btn {
    margin-left: 10px;
  }
  /deep/ .titleBox {
    margin-bottom: 0px;
  }
}
.magin-t16 {
  margin-top: 16px;
}
.basicInfo {
  margin-bottom: 32px;
  /deep/.el-form-item--small.el-form-item {
    width: 400px;
  }
}
.displayItem {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.basicTitle {
  font-size: 12px;
  font-weight: 400;
  color: #333333;
  width: 300px;
  .span {
    color: #666666;
  }
}

.my_select_time1 {
  position: relative;
  display: inline-block;
  .time2 {
    width: 145px;
  }
  /deep/.el-input--prefix .el-input__inner {
    padding-left: 10px;
  }
  .date_icon2,
  .date_icon1 {
    position: absolute;
    /* top: 10px; */
    right: 5px;
    height: 32px;
    line-height: 32px;
    width: 16px;
    font-size: 16px;
  }

  .date_icon1 {
    display: none;
    cursor: pointer;
  }
}

.my_select_time1:hover {
  .date_icon2 {
    display: none;
  }

  .date_icon1 {
    display: inline-block;
  }
}

.editIcon {
  height: 16px;
  margin: 2px 0 0 15px;
  .edit_active {
    display: none;
  }
  .edit {
    display: block;
  }
  &:hover {
    .edit {
      display: none;
    }
    .edit_active {
      display: block;
    }
  }
}
</style>